import { createContext } from 'react';

import type { VBaseCheckboxRadioGroupContextValue } from './type';

export const VBaseCheckboxRadioGroupContext = createContext<
  VBaseCheckboxRadioGroupContextValue<any, any>
>(null!);
